import HOCWatchValue from 'components/common/hoc-watch-value';
import TableEditableComponent from 'components/elements/table/table';
import { ColumnDataType } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';

export default function ProductPurchaseTable() {
  const { t } = useTranslation();
  const name: any = 'approvalable.productPurchases';
  const value = HOCWatchValue({ keys: [name] });
  const data = value[name];

  const columns = [
    {
      header: t('product:product-variant'),
      accessorKey: 'productVariantName',
      minSize: 400,
      dataType: ColumnDataType.text,
    },
    {
      header: t('product:price_per_item'),
      accessorKey: 'price',
      minSize: 100,
      dataType: ColumnDataType.number,
      minNumber: 0,
      required: true,
    },
    {
      header: t('common:quantity'),
      accessorKey: 'qty',
      minSize: 100,
      dataType: ColumnDataType.number,
      minNumber: 0,
      required: true,
    },
    {
      header: t('common:description'),
      accessorKey: 'description',
      minSize: 500,
      dataType: ColumnDataType.text,
    },
  ];

  return (
    <div style={{ width: '100%' }}>
      <TableEditableComponent
        columns={columns}
        data={data}
        dispatch={() => {}}
        disabled
        name={name}
      />
    </div>
  );
}
